export default "__VITE_ASSET__BnczUIg6__"